export default function ViewPeopleModal() {
  return null;
}
